// extracted by mini-css-extract-plugin
export default {"wrapper":"column-configuration_wrapper__5qNKl"};